export { MUX_ENV_KEY } from 'constants/runtimeConfig';
